import { kea } from 'kea'
import { cartReducers, cartSelectors } from "@gratify-eu/entities"


const logic = kea({
  path: () => ['entities'],

  reducers: ({actions, constants}) => (cartReducers),
  selectors: cartSelectors
})

const unmount = logic.mount();
export default logic
